import { EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

export interface IDemographicsForm {
  Busy$: BehaviorSubject<boolean>;
  saveDataEvent: EventEmitter<{ Note: DemographicsNote, MailingList: string }>;
  demographicsForm: UntypedFormGroup;

  SaveDemographics(data: DemographicsNote);
}

export class DemographicsNote {
  public Subject: 'Instructor Demographics';
  public Note: string;

  public constructor(subject: 'Instructor Demographics', note: string) {
    this.Subject = subject;
    this.Note = note;
  }
}
